export enum IdentityProvider {
    Google = 'Google',
    Cognito = 'COGNITO',
}
